import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { register as apiRegister } from '../api/api';
import { AuthLanding, AuthModal, PasswordInput, PasswordRequirements } from '../components/AuthShell';

// Mínimo 10 caracteres, mayúscula, minúscula, número y símbolo — debe coincidir con
// PASSWORD_RE en server.js.
const PASSWORD_RE = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s]).{10,}$/;
const PASSWORD_HINT = 'Mínimo 10 caracteres, con mayúscula, minúscula, número y símbolo.';

function Register() {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);
  const [form, setForm] = useState({ name: '', email: '', password: '', password2: '' });
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    axios.get('/api/profile', { withCredentials: true })
      .then(() => navigate('/dashboard'))
      .catch(() => setChecking(false));
  }, [navigate]);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    if (!form.name.trim()) return setError('El nombre completo es obligatorio');
    if (!PASSWORD_RE.test(form.password)) return setError(PASSWORD_HINT);
    if (form.password !== form.password2) return setError('Las contraseñas no coinciden');

    setSubmitting(true);
    try {
      // El servidor sigue exigiendo accepted_privacy en el body — se manda en true
      // porque quitamos el checkbox del formulario "por ahora"; si se reactiva el
      // checkbox, volver a capturar el valor real aquí.
      await apiRegister({ name: form.name.trim(), email: form.email.trim(), password: form.password, accepted_privacy: true });
      navigate('/mi-perfil');
      window.location.reload();
    } catch (err) {
      setError(err.response?.data?.error || 'No se pudo crear la cuenta');
    }
    setSubmitting(false);
  };

  if (checking) return <div className="state-message"><p>Cargando...</p></div>;

  return (
    <AuthLanding>
      <div className="login-cta-row">
        <p className="login-cta-hint">
          Completa tus datos para unirte a la red. Un administrador aprueba tu cuenta después.
        </p>
      </div>

      <AuthModal title="Crear cuenta" onClose={() => navigate('/')}>
        <form onSubmit={handleSubmit}>
          {error && <div className="msg-banner error">{error}</div>}
          <div className="form-group">
            <label className="form-label">Nombre completo</label>
            <input type="text" name="name" value={form.name} onChange={handleChange} required className="form-input" autoFocus />
          </div>
          <div className="form-group">
            <label className="form-label">Correo electrónico</label>
            <input type="email" name="email" value={form.email} onChange={handleChange} required className="form-input" />
          </div>
          <div className="form-group">
            <label className="form-label">Contraseña</label>
            <PasswordInput name="password" value={form.password} onChange={handleChange} required minLength={10} />
            <PasswordRequirements password={form.password} />
          </div>
          <div className="form-group">
            <label className="form-label">Confirmar contraseña</label>
            <PasswordInput name="password2" value={form.password2} onChange={handleChange} required minLength={10} />
          </div>
          <button type="submit" disabled={submitting} className="btn btn-primary btn-block" style={{ marginBottom: '10px' }}>
            {submitting ? 'Creando cuenta...' : 'Unirme a la red'}
          </button>
        </form>
      </AuthModal>
    </AuthLanding>
  );
}

export default Register;
